// Build identity of the deployed PMP agent. About shows the release; the commit stays in the
// response for whoever is looking at a redeploy of the same release, where the number does not move.
//
// GET /version is anonymous and sends no headers, so it stays a simple cross-origin request and
// needs no preflight.

export interface AgentBuildInfo {
  version: string;
  commit: string;
}

// Returns null whenever the agent has no usable URL here (unset or an unresolved config
// placeholder) or does not answer, so About can leave the row out entirely rather than showing a
// dash, which would read as "deployed but broken".
export async function fetchAgentVersion(agentUrl: string | undefined, signal?: AbortSignal): Promise<AgentBuildInfo | null> {
  if (!agentUrl) return null;

  let endpoint: string;
  try {
    endpoint = new URL('/version', agentUrl).toString();
  } catch {
    return null;
  }

  try {
    const response = await fetch(endpoint, { signal });
    if (!response.ok) return null;

    const body = (await response.json()) as Partial<AgentBuildInfo> | null;
    if (!body?.version) return null;

    return { version: body.version, commit: body.commit ?? '' };
  } catch {
    return null;
  }
}
